import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const getters = {
  getTeams($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getTeamById: $state => id => {
    return (
      Object.values($state.records).find(record => record.id === Number(id)) ||
      {}
    );
  },
  getMyTeams($state, $getters) {
    return $getters.getTeams.filter(team => {
      const { is_member: isMember } = team;
      return isMember;
    });
  },
  // Teams the current user may assign conversations to.
  // Everyone can assign any account team; with `restrict_conversation_assignment`
  // on, both agents and administrators are scoped to their memberships.
  getAssignableTeams($state, $getters, _rootState, rootGetters) {
    const isRestricted = rootGetters['accounts/isFeatureEnabledonAccount'](
      rootGetters.getCurrentAccountId,
      FEATURE_FLAGS.RESTRICT_CONVERSATION_ASSIGNMENT
    );

    if (!isRestricted) {
      return $getters.getTeams;
    }

    // Leaders may assign to a team they lead even without being a member of it,
    // mirroring TeamAssignmentAuthorization on the backend.
    return $getters.getTeams.filter(
      ({ is_member: isMember, is_leader: isLeader }) => isMember || isLeader
    );
  },
  getLedTeams($state, $getters) {
    return $getters.getTeams.filter(team => team.is_leader);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getTeam: $state => id => {
    const team = $state.records[id];
    return team || {};
  },
};
